import { MapUtils } from '../../utility/map-utils.js';
import { cloneListOfCloneable, DataModel, DataModelBuilder, isSameData, isSameList,
  SerializationContext, SerializedData } from '../dto/dto.js';
import { Subscription } from './subscription.js';

export class BillingAccount extends DataModel {
  static readonly TYPE_ID: string = '94f1aa96d2254dcfb017b13d2b981a60';

  constructor(
    public readonly uniqueId: string,
    public readonly subscriptions: Subscription[],
  ) {
    super();
  }

  get $typeId(): string {
    return BillingAccount.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): BillingAccount {
    return new BillingAccount(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.getList(map, 'subscription', (data) => context.fromData(data as SerializedData)),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'subscriptions': this.subscriptions.map((e) => context.toData(e)),
    };
  }

  clone(): this {
    return new BillingAccount(
        this.uniqueId,
        cloneListOfCloneable(this.subscriptions),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        isSameList(other.subscriptions, this.subscriptions, (a, b) => isSameData(a, b));
  }
}

export class BillingAccountBuilder extends DataModelBuilder<BillingAccount> {
  build(context: SerializationContext, map: SerializedData): BillingAccount {
    return BillingAccount.fromMap(context, map);
  }
}
